export default "__VITE_ASSET__9WTGnktH__";